// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createOrEditRoot[data-v-01329eca],.fullContainer[data-v-01329eca]{height:100%}.resourceFormPage__form[data-v-01329eca]{display:flex;flex-direction:column;min-height:100%}", ""]);
// Exports
module.exports = exports;
